/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const o=1,t=[0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1],i=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],n=256,e={outlineWidth:1.3,outerHaloWidth:.4,innerHaloWidth:.4,outlinePosition:0};export{t as alphaToRgbaChannelSelectorMatrix,e as highlightSizing,i as rgbaToRgbaChannelSelectorMatrix,n as shadeTextureSize,o as sigma};
